module.exports = __webpack_public_path__ + "static/media/PH3800__006_Froggy.57d7e634.mp3";